export default __webpack_public_path__ + "static/media/JohnCarmackResume.d6863d71.pdf";